export const NO_DATA_PROVIDER_ID = "N/A N/D";
